import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import AuthBypassWatermark from './components/AuthBypassWatermark';
import ErrorBoundary from './components/ErrorBoundary';

// Pages
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import AdminPage from './pages/AdminPage';
import TeacherSetup from './pages/TeacherSetup';
import StudentSession from './pages/StudentSession';
import ScenarioLibrary from './pages/ScenarioLibrary';
import SCASetup from './pages/SCASetup';
import SCASession from './pages/SCASession';
import SCAReview from './pages/SCAReview';
import TTSAdminPage from './pages/TTSAdminPage';

const AppContent = () => {
  const { authBypassActive, user } = useAuth();

  return (
    <ErrorBoundary user={user}>
      <div className="app-shell">
        {authBypassActive && <AuthBypassWatermark />}
        <Toaster position="top-right" />
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />

          {/* Protected routes */}
          <Route element={<Layout />}>
            <Route path="/" element={<Navigate to="/teacher" replace />} />
            {/* Dashboard removed */}
            <Route
              path="/teacher"
              element={
                <ProtectedRoute>
                  <TeacherSetup />
                </ProtectedRoute>
              }
            />
            {/* Admin removed */}
            <Route
              path="/teacher"
              element={
                <ProtectedRoute>
                  <TeacherSetup />
                </ProtectedRoute>
              }
            />
            <Route
              path="/library"
              element={
                <ProtectedRoute>
                  <ScenarioLibrary />
                </ProtectedRoute>
              }
            />
            <Route
              path="/simulation/:sessionId"
              element={
                <ProtectedRoute>
                  <StudentSession />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sca"
              element={
                <ProtectedRoute>
                  <SCASetup />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sca/simulation/:sessionId"
              element={
                <ProtectedRoute>
                  <SCASession />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sca/review/:sessionId"
              element={
                <ProtectedRoute>
                  <SCAReview />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/tts"
              element={
                <ProtectedRoute requireAdmin>
                  <TTSAdminPage />
                </ProtectedRoute>
              }
            />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    </ErrorBoundary>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
